const logEmptyFunctionWarning = (callerName, className, verbose = false) => verbose &&
    console.warn(`${className ? className + ": " : ""}${callerName} not implemented.`);
export default logEmptyFunctionWarning;
